<template>
    <h1>Redirecting</h1>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import { useLoaderStore } from "@/store/loader"
import { useEntityRoute } from '@/composables/route/useListViewRoute'
import {exchangeAuthenticationCodeForToken} from "@/services/webservice"
import { usePathController } from '@/composables/usePathController'
import {useLogger} from "@/composables/useLogger"
const {sendLog} = useLogger()
const loader = useLoaderStore()
const { goToHome , goToLogin, followRedirection} = usePathController()
onMounted(async () => {
    loader.show()
    const { authentication_code , ssoState} = useEntityRoute()
    try{
        const response = await exchangeAuthenticationCodeForToken(authentication_code.value, ssoState.value)
        followRedirection(response.data)
    }catch(error){
        sendLog("error", 'sso_code_exchange_fail', {
            error,
            metadata: {authentication_code, ssoState}
        })
        goToLogin(error?.response?.data?.message || error.message)

    }finally{
        loader.hide()
    }
    
}) 

</script>